import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { ThirdPartyPayoff } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface RespondToThirdPartyPayoffRemovalRequest {
    engagementId: number;
    tableRowId: number;
    approve: boolean;
}

// An approved removal soft-deletes the row server-side (it never returns from
// reads), so the slice drops the row from state instead of merging the
// response back in.
export const RespondToThirdPartyPayoffRemoval = createAsyncThunk(
    'flowOfFunds/respondToThirdPartyPayoffRemoval',
    async (params: RespondToThirdPartyPayoffRemovalRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/flowOfFunds/${params.engagementId}/thirdPartyPayoffs/rows/${params.tableRowId}/removalProposal/response`,
                {
                    approve: params.approve,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to respond to the removal proposal');
            }

            return response.data as ThirdPartyPayoff;
        } catch (error) {
            createNotification(
                'Could not respond to the removal proposal.',
                'error'
            );
            throw error;
        }
    }
);
